import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function Policies() {
  const [p, setP] = useState(null);

  useEffect(() => { api.get("/policy").then(({ data }) => setP(data)); }, []);

  if (!p) return null;

  const save = async () => {
    try {
      await api.put("/policy", {
        office_start_time: p.office_start_time,
        office_end_time: p.office_end_time,
        grace_period_minutes: Number(p.grace_period_minutes),
        late_threshold_minutes: Number(p.late_threshold_minutes),
        early_departure_minutes: Number(p.early_departure_minutes),
        min_working_hours: Number(p.min_working_hours),
        presence_check_interval_minutes: Number(p.presence_check_interval_minutes),
        presence_check_enabled: !!p.presence_check_enabled,
      });
      toast.success("Policy updated");
    } catch (e) { toast.error("Failed"); }
  };

  const Field = ({ k, label, type = "text" }) => (
    <div>
      <Label className="label-mono">{label}</Label>
      <Input data-testid={`policy-${k}`} type={type} value={p[k]} onChange={(e) => setP({ ...p, [k]: e.target.value })} className="rounded-none font-mono-brand" />
    </div>
  );

  return (
    <>
      <PageHeader eyebrow="Configuration" title="Attendance Policies" subtitle="How Attendly decides who is late, on-time, or absent" />
      <div className="p-8">
        <Card className="rounded-none border-border p-6 max-w-2xl space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <Field k="office_start_time" label="Office start (HH:MM UTC)" />
            <Field k="office_end_time" label="Office end (HH:MM UTC)" />
            <Field k="grace_period_minutes" label="Grace period (min)" type="number" />
            <Field k="late_threshold_minutes" label="Late threshold (min)" type="number" />
            <Field k="early_departure_minutes" label="Early departure (min)" type="number" />
            <Field k="min_working_hours" label="Min working hours" type="number" />
          </div>

          <div className="border-t border-border pt-4 space-y-3">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium">Presence checks</div>
                <div className="label-mono">Employees ping their GPS periodically while punched-in.</div>
              </div>
              <Switch
                data-testid="policy-presence-enabled"
                checked={!!p.presence_check_enabled}
                onCheckedChange={(v) => setP({ ...p, presence_check_enabled: v })}
              />
            </div>
            <div className="max-w-xs">
              <Field k="presence_check_interval_minutes" label="Check interval (min)" type="number" />
              <div className="label-mono mt-1">Every ping outside a geofence is logged as a breach and notifies Center Admins.</div>
            </div>
          </div>

          <div className="pt-2">
            <Button data-testid="policy-save-btn" onClick={save} className="rounded-none btn-primary-brand">Save policy</Button>
          </div>
        </Card>
      </div>
    </>
  );
}
